// extracted by mini-css-extract-plugin
module.exports = {"container":"header_content-module__container--1WCu4"};